import React from 'react'
import PropTypes from 'prop-types'
import AssetClass from '../AssetClass/AssetClass'
import { UNASSIGNED_ASSETS } from 'utils/Client/classAllocationsConfig.js'
import classnames from 'classnames'

import styles from './AssetClassBreakdown.module.scss'

// eslint-disable-next-line
function * groupInTwo (array) {
  let group = []
  for (let i = 0; i < array.length; ++i) {
    group.push(array[i])
    if (i % 2 === 1 || i + 1 === array.length) {
      yield group
      group = []
    }
  }
}

const AssetClassBreakdown = (props) => {
  const {
    model,
    ownClasses,
  } = props

  const getAssetColumn = (assetColumnNumber, group) => (
    <div key={assetColumnNumber} className={styles.assetColumn}>
      {
        group.map((classAllocation, index) => {
          const dataTestId = `${(classAllocation.className).split(' ').join('')}-testId`
          return (
            <AssetClass
              key={classAllocation.classId}
              testId={dataTestId}
              percentage={classAllocation.percentage}
              isUnassigned={classAllocation.className === UNASSIGNED_ASSETS.name}
              classAllocationName={classAllocation.className} />
          )
        })
      }
    </div>
  )

  const getAssetClasses = (models) => {
    const columns = []
    let assetColumnNumber = 0
    let column
    for (const group of groupInTwo(models)) {
      column = getAssetColumn(assetColumnNumber, group)
      columns.push(column)
      assetColumnNumber += 1
    }
    return columns
  }

  const classes = classnames(styles.AssetClassBreakdown, {
    [ownClasses]: !!ownClasses
  })

  return (
    <div className={classes}>
      <div data-test-id="assetClassBreakdownId" className={styles.columnsGroup}>
        {model && getAssetClasses(model)}
      </div>
      <div className={styles.divider} />
    </div>
  )
}

AssetClassBreakdown.defaultProps = {
  ownClasses: null,
}

AssetClassBreakdown.propTypes = {
  model: PropTypes.array.isRequired,
  ownClasses: PropTypes.string,
}

export default AssetClassBreakdown



// WEBPACK FOOTER //
// ./src/components/Client/AssetClassBreakdown/AssetClassBreakdown.jsx